import React, {useState} from 'react'
import './Family.css';
import './RelativeFamily.css'


import Person from './Person'
import Modal from './Modal';


// DB
import { db } from '../utils/User/include/Authorize'
import { useStateValue } from '../utils/Provider/StateProvider';
import InnerFamilyTreeView from './InnerFamilyTreeView';


function RelativeFamily() {
    const [{ user, myrelative }] = useStateValue();

    const [showAddModal, setShowModal] = useState(false)
    
    const [showHiddenPlot, setShowHiddenPlot] = useState(false)
    const [plotNode, setPlotNode] = useState()
    const [plotEdge, setPlotEdge] = useState()

    const [personName, setPersonName] = useState('');
    const [familyName, setFamilyName] = useState('');
    const [DOB, setDOB] = useState('');
    const [relation_is, setRelation_is] = useState('My Self');
    const [custom_relation, setCustomRelation] = useState('');
    const [IcallHim, setICallHim] = useState('kaka');
    const [custom_ICallHim, setCustomICallHim] = useState('');
    const [is_married, setIsMarried] = useState('');
    const [married_to, setMarriedTo] = useState('');
    const [contact_detail, setContactDetail] = useState('');
    const [location_detail,setLocationDetail ] = useState('');
    const [describe_person,setDescribePerson ] = useState('');
    const [errorNotify,setErrorNotify ] = useState('💡 No Suggestions');

    const [person_data,setPersonData ] = useState([]);
    const [currentFam,setCurrentFam ] = useState("");
    const [currentUuid,setCurrentUuid ] = useState("");




    const DeleteFamily = (para) => {
        

        if(user && para.uuid){
            db.collection(user.email)
                .doc('Relative')
                .collection('members')
                .doc(para.uuid)
                .delete()
        }
    
    }

    const AddMember = (data) => {
        console.log('ADDING ...', data)
        setCurrentFam(data.person_data)
        setCurrentUuid(data.uuid)
        setShowModal(true);
        
    }

    const color = [
        'rgb(243, 125, 14)',
        'rgb(226, 35, 35)',
        'rgb(243, 239, 14)',
        'rgb(136, 255, 0)',
        'rgb(78, 172, 70)',
        'rgb(199, 12, 143)',
        'rgb(45, 124, 243)',
        'rgb(47, 187, 187)',
        'rgb(226, 35, 153)',
        'rgb(226, 35, 226)',
        'rgb(194, 96, 51)',
        'orangered',
        'salmon',
        'darkcyan',
        'gold',
        'goldenrod',
        'purple'
    ]

    // Const Choose Color Randomly:
    const getColor = () => {
        const len = color.length;
        return color[Math.floor(Math.random() * len)]
    }

    // Add Person to data State
    const addPerson = () => {
        
        if(personName === ''){
            setErrorNotify("❗ Name is required")
        }
        // else if (DOB === ""){
        //     setErrorNotify("❗ DOB is required")
        // }
        else if (relation_is !== "custom" && custom_relation !== ""){
            setErrorNotify("❗ Relation_type is not custom. Please, remove this field ")
        }
        else if (relation_is === "custom" && custom_relation === ""){
            setErrorNotify("❗ Custom selected but {empty-field}")
        }
        else if (IcallHim !== "custom" && custom_ICallHim !== ""){
            setErrorNotify("❗ 'call him' is not custom. Please, remove this field ")
        }
        else if (IcallHim === "custom" && custom_ICallHim === ""){
            setErrorNotify("❗ Custom 'call him' selected but {empty-field}")
        }
        else if (is_married === ''){
            setErrorNotify("❗ Marriage Status required")
        }
        else if (is_married === 'yes' && married_to === ""){
            setErrorNotify("❗ Married with Field required ")
        }
        else if (is_married === 'no' && married_to !== ""){
            setErrorNotify("❗ Wrong Entry [Person is not married Field must be Empty")
        }
        else{
            setErrorNotify("✔️ No errors found")

            person_data.push({
                'family_name' : currentFam[0].family_name,
                'name' : personName,
                'DOB' : DOB === '' ? null : DOB,
                'relation_is' : relation_is,
                'custom_relation' : custom_relation === '' ? null : custom_relation,
                'call_him' : IcallHim ,
                'custom_call_him' : custom_ICallHim === '' ? null : custom_ICallHim,
                'is_married': is_married,
                'married_to' : married_to === '' ? null : married_to,
                'contact_detail' : contact_detail === '' ? null : contact_detail,
                'location_detail' : location_detail === '' ? null : location_detail,
                'describe_person' : describe_person === '' ? null : describe_person,
                'bgcolor' : `${getColor()}`,
                'uploadProfileImg': [],
                'known_by': currentFam[0].known_by,
                'known_as': currentFam[0].known_as,
                'custom_knownas': currentFam[0].custom_knownas === '' ? null : currentFam[0].custom_knownas,
            })


            resetFields()
            FinalMemberToAdd()
            
        } 
    }

    // Add to the DB:
    const FinalMemberToAdd = () => {
        const data = []

        person_data.map(i => {
            data.push(i)
        })

        currentFam.map(i => {
            data.push(i)
        })


        if(user){
            db.collection(user.email)
                .doc("Relative")
                .collection('members')
                .doc(currentUuid)
                .update({person_data : data})
        }

        
        console.log(data, currentUuid)
        setCurrentFam("")
        setCurrentUuid("")
        setPersonData([])
        setShowModal(false)
    }

    // Clear all Field States:
    const resetFields = () =>{

        setPersonName('')
        setDOB('')
        setRelation_is('My Self')
        setCustomRelation('')
        setICallHim('Kaka')
        setCustomICallHim('')
        setIsMarried('')
        setMarriedTo('')
        setContactDetail('')
        setLocationDetail('')
        setDescribePerson('')

    }

    // make nodes and edges:
    let ix=10, iy=30;
    const getPostition = (type) => {
        

        if(type === 'father'){
            return {x: 0, y: 50}
        }

        else if(type === 'mother'){
            return {x: 350, y: 50}
        }

        else if(type === 'son'){
            const temp = {x: 100 + ix, y: 350 + iy}
            ix += 10
            iy += 50
            return temp
        }

        else if(type === 'daughter'){
            const temp = {x: 100+250 + ix, y: 300+iy}
            ix -= 100
            iy += 150
            return temp
        }

        else{
            return {x: 300, y: 150}
        }


    }

    const mapColors = {
        'friend': 'yellow',
        'father': 'pink',
        'brother': 'blue',
        'sister': 'skyblue',
        'son': 'green',
        'daughter': 'lightgreen',
        'mama': 'orange',
        'mami': 'brown',
        'maushi': 'maroon',
        'aatya': 'magenta',
        'custom': 'grey'
    }

    const findLink = (e) => {
        if(e === 'father'){
            return 'mother'
        } 
        else if(e === 'son') {
            return 'father'
        }

        else if(e === 'daughter') {
            return 'mother'
        }

        else{
            return 'mother'
        }
    }


    const constructTree = (e) => {
        
        let node = [], edge = [];

        Object.keys(e.person_data).map(id => {
            const Nodetest = {
                id: e.person_data[id].relation_is,
                data: {
                  label: (
                    <>
                      <strong>{e.person_data[id].name} ({e.person_data[id].relation_is}) </strong> <br />
                      ({e.person_data[id].call_him === 'custom' ? e.person_data[id].custom_call_him : e.person_data[id].call_him})
                    </>
                  ),
                },
                position: getPostition(e.person_data[id].relation_is),
                style: {
                    background: e.person_data[id].relation_is === 'custom' ? mapColors['custom'] : mapColors[e.person_data[id].relation_is],
                    color: '#333',
                    border: '1px solid #222138',
                    borderRadius: '10px',
                    padding: '5px 10px',
                    width: 180,
                },
            }

            node.push(Nodetest)


            const edgeTest ={
                    id: e.uuid + "-" + id,
                    source: 'father',
                    target:  'son',
                    label: 'smooth step edge',
                    labelStyle: { fill: '#f6ab6c', fontWeight: 700 },
                }
            edge.push(edgeTest)
        })
       
        
          
        
        console.log(node, edge)
        console.log(e)
       

        // setPlotEdge(edge)
        setPlotNode(node)
          
    }

    

    
  return (
    <div className='family_card_container'>
        
        {myrelative ?
                (
                    Object.keys(myrelative).map(i => (
                        <div className='family_card_container_mainDiv'>

                            {myrelative[i].person_data[0] ?
                                <div className='family_card_container_mainDiv_title'>
                                    <h3>{myrelative[i].person_data[0].family_name}</h3>

                                    <div className='family_card_container_mainDiv_title_right flex-row-spaceBetween'>
                                        <p>{myrelative[i].uuid}</p>
                                        <i class="fa fa-trash" aria-hidden="true" onClick={() => DeleteFamily(myrelative[i])}></i>
                                        <i class="fa fa-plus" aria-hidden="true" onClick={() => AddMember(myrelative[i])}></i>
                                        <i class="fa fa-code-fork" aria-hidden="true" onClick={() => {setShowHiddenPlot(true); constructTree(myrelative[i])}}></i>
                                    </div>
                                </div>
                            :
                                null
                            }
                            
                            <div className='family_card_container_mainDiv_people'>
                                {   
                                    myrelative[i].person_data.map((person, index) => (
                                        <Person details={person} uuid={myrelative[i].uuid} familyId={i} personId={index}/>
                                    ))
                                }
                            </div>
                        </div>      
                    ))
                )                
            
        :
            null
        }


        {showHiddenPlot && 
            <Modal onCloseHandler={() => setShowHiddenPlot(false)} title="Happy Family !">
                <div>
                    <InnerFamilyTreeView nodes={plotNode} edges={plotEdge}/>
                </div>
            </Modal>
        }


        {showAddModal && 
            <Modal onCloseHandler={() => setShowModal(false)} title="Add new member to this family">
                <div>
                <div className='addfamily_modal_step1'>
                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='person_name'>Name: &nbsp;</label>
                            <input type='text' className='max_width700' id='person_name' placeholder='Person Name' value={personName} onChange={e => setPersonName(e.target.value)} />
                        </div>

                        <div>
                            <label for='person_dob'>DOB: &nbsp;</label>
                            <input type='date' className='max_width700' id='person_dob' value={DOB} checked onChange={e => setDOB(e.target.value)} />
                        </div>
                    </div>

                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='relation_is'>{personName ? personName : 'Person'} is a (with-in this family) : &nbsp;</label>

                            <select id='relation_is'  value={relation_is} onChange={e => setRelation_is(e.target.value)} >
                                <option value='myself' selected>My Self</option>
                                <option value='father'>Father</option>
                                <option value='mother'>Mother</option>
                                <option value='son'>Son</option>
                                <option value='daughter'>Daughter</option>
                                <option value='sister'>Sister</option>
                                <option value='brother'>Brother</option>
                                <option value='kaka'>Kaka</option>
                                <option value='kaku'>Kaku</option>
                                <option value='mama'>Mama</option>
                                <option value='aatya'>Aatya</option>
                                <option value='mami'>Mami</option>
                                <option value='maushi'>Maushi</option>
                                <option value='custom'>Custom</option>
                            </select>

                            <input type='text' className='max_width700' id='custom_relation' placeholder='if custom enter here'  value={custom_relation} onChange={e => setCustomRelation(e.target.value)} />
                            
                        </div>
                    </div>
                    <p style={{marginTop: '0px', fontSize:'12px', color:'#ccc' }}>This means who is he/her in his Family eg(he is a father, his wife so a mother, their son, etc)</p>
                    
                    
                    <hr />
                    {/* I call Him Part */}
                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='i_call_him'>You call ({personName ? personName : 'Person'}) : &nbsp;</label>

                            <select id='i_call_him'  value={IcallHim} onChange={e => setICallHim(e.target.value)} >
                                <option value='father'>Father</option>
                                <option value='mother'>Mother</option>
                                <option value='sister'>Sister</option>
                                <option value='brother'>Brother</option>
                                <option value='kaka' selected>Kaka</option>
                                <option value='kaku'>Kaku</option>
                                <option value='mama'>Mama</option>
                                <option value='aatya'>Aatya</option>
                                <option value='mami'>Mami</option>
                                <option value='maushi'>Maushi</option>
                                <option value='custom'>Custom</option>
                            </select>

                            <input type='text' className='max_width700' id='custom_relation' placeholder='if custom enter here'  value={custom_ICallHim} onChange={e => setCustomICallHim(e.target.value)} />
                            
                        </div>
                    </div>
                    <p style={{marginTop: '0px', fontSize:'12px', color:'#ccc' }}>By what you call him/her eg(your uncle, etc)</p>


                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='is_married'>Married: &nbsp;</label>
                            <input type='radio' id='is_married' name='married_status' value='yes' onClick={e => setIsMarried(e.target.value)} /> Yes &nbsp;
                            <input type='radio' id='is_married' name='married_status' value='no' onClick={e => setIsMarried(e.target.value)} /> No &nbsp;
                        </div>

                        <div>
                            <label for='married_to'>Married with : &nbsp;</label>
                            <input type='text' className='max_width700' id='married_to' placeholder='If yes then Married with ? ' value={married_to}  onChange={e => setMarriedTo(e.target.value)}  />
                        </div>
                    </div>

                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='contact_detail'>Contact: &nbsp;</label>
                            <input type='tel' className='max_width700' id='contact_detail' placeholder='Contact' value={contact_detail}  onChange={e => setContactDetail(e.target.value)} />
                        </div>

                        <div>
                            <label for='location_detail'>Location: &nbsp;</label>
                            <input type='text' className='max_width700' id='location_detail' placeholder='Stays in '  value={location_detail}  onChange={e => setLocationDetail(e.target.value)}  />
                        </div>
                    </div>


                    <br></br>
                    <label for='describe_person' style={{marginBottom: '10px'}}>Description : &nbsp;</label>
                    <br />
                    <textarea id='describe_person' className='max_width700' placeholder='Describe more about person' noresize  value={describe_person}  onChange={e => setDescribePerson(e.target.value)} ></textarea>

                    {/* <p>{uploadImage}</p> */}

                    {/* { uploadImage === '' ?
                        null
                        :
                        <button id='uploac_img' className='addfamily_modal_upload_btn' onClick={() => UploadImageToDB()} >Upload</button>
                    } */}


                {/* Remove Upload Button, Add Person Name to image and upload img on submit Event  */}


                    
                    
                </div>
                <hr />
                <div className='addfamily_modal_buttons'>  
                    <div><span id='verification_msg' style={errorNotify === '✔️ No errors found' ? {backgroundColor: 'rgb(88, 255, 88)'} : null}>{errorNotify ? errorNotify : null}</span></div>

                    <div>
                        <button className='addfamily_person_btn' onClick={() => addPerson()}>Add person</button>
                    </div>
                </div>
                </div>
            </Modal>
        }
        
    </div>
  )
}

export default RelativeFamily
